import {
  MobileLayout,
  MobileLayoutProps,
} from 'components/mobile/MobileLayout/MobileLayout';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { DesktopLayoutProps, Layout } from './Layout';

interface Props {
  children: React.ReactNode;
  mobileLayoutProps?: MobileLayoutProps;
  desktopLayoutProps?: DesktopLayoutProps;
}

export const DeviceSpecificLayout = ({
  children,
  mobileLayoutProps,
  desktopLayoutProps,
}: Props) => {
  const { isMobile } = useBreakpoint();

  return (
    <>
      {isMobile ? (
        <MobileLayout {...mobileLayoutProps}>{children}</MobileLayout>
      ) : (
        <Layout {...desktopLayoutProps}>{children}</Layout>
      )}
    </>
  );
};
